import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { truncateString } from 'utils/truncateString';

type Props = {
  commissionName: string;
  onAgreement: () => void;
} & DialogProps;

export const CommissionsRefundSuccessDialog: React.FC<Props> = ({
  commissionName,
  onAgreement,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Dialog {...restProps} fullWidth width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          title="Создание комиссий успешно выполнено"
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            Новая комиссия{' '}
            <Typography component="span" fontWeight={500}>
              {truncateString(commissionName, 30)}
            </Typography>{' '}
            успешно создана. Дополнительно созданы отдельные комиссии с типами транзакций
            &quot;Рефанд&quot; и &quot;Чарджбек&quot;. Вы можете перейти к просмотру основной
            комиссии или вернуться к списку комиссий для дальнейшей работы.
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="back-button"
              label={translate('app.merchantCommissions.backToList')}
              onClick={restProps.onClose}
              variant="outlined"
            />,
            <Button
              color="primary"
              key="btn-agreement"
              label={translate('app.merchantCommissions.view')}
              onClick={onAgreement}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
